import React from 'react';
import styles from './LargeEventCard.module.css';

const LargeEventCard = ({ location, event, month, image }) => {
  return(
    <div className={styles.LargeEventCardWrapper}>
      <img src={image} alt="" />
      <p className={styles.LargeEventCardLocation}>{location}</p>
      <p className={styles.LargeEventCardName}>{event}</p>
      <p className={styles.LargeEventCardMonth}>{month}</p>
    </div>
  )
}

export default LargeEventCard;



// WEBPACK FOOTER //
// ./src/components/LargeEventCard/LargeEventCard.jsx